import { useCookies } from 'react-cookie'

import { COOKIE_KEYS } from '@shared/contants'

export default function useIsAdult () {
  let isAdult = false
  const [ cookies, setCookies ] = useCookies([ COOKIE_KEYS.IS_ADULT ])

  isAdult = !!cookies.isAdult

  const setIsAdult = (value: boolean) => {
    setCookies(COOKIE_KEYS.IS_ADULT, value)
  }

  return {
    isAdult,
    setIsAdult,
  }
}
